import React, { useEffect, useState } from 'react';
import { Button, TextField, FormControl, FormControlLabel, Checkbox, Tabs, Tab, Box} from '@mui/material';
import apiInstance from '../../../../services/ServiceApi';
import PermissionsComponent from './PermisosList';
import SelectLineaNegocio from '../lineaNegocio/SelectLineaNegocio';
import EmpresaDetailList from '../../../../components/empresa/EmpresaDetailList';

function CreateUser({closeModal,onUserCreated, isEditMode, userId  }) {
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        type_document: "",
        first_name: "",
        last_name: "",
        dni: "",
        phone: null,
        email: null,
        is_active: false,
        is_superuser: false,
        is_staff: false
    });
    const [tabValue, setTabValue] = useState(0);
    const [permisos, setPermisos] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [lineaSeleccionada, setLineaSeleccionada] = useState([]);
    const [dashboardSeleccionado, setDashboardSeleccionado] = useState([]);

    const handleChange = (event) => {
        const { name, value, checked } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: name === "is_active" || name === "is_superuser" || name === "is_staff" ? checked : value
        }));
    };
    const handleSelectedData = (selectedPerms, selectedGrps) => {
        setPermisos(selectedPerms)
        setGrupos(selectedGrps)
    };
    
    const handleSubmit = async (event) => {
        event.preventDefault();
    
        const createUser = async (data) => {
            const response = await apiInstance.post('/manageuser/', data);
            return response.data.id; // Retorna el ID del nuevo usuario
        };
    
        const updateUser = async (userId, data) => {
            await apiInstance.patch(`/manageuser/${userId}/`, data);
        };
    
        const assignPermissions = async (userId, permissionsData) => {
            await apiInstance.post('/user/asignarpermiso/', permissionsData);
        };
    
        try {
            let userIdToUse = userId;
            let submitData = {
                ...formData
            };
            if (isEditMode) {
                // Si es edición, elimina la contraseña y actualiza el usuario
                delete submitData.password;
                await updateUser(userId, submitData);
            } else {
                // Si es creación, crea el usuario y utiliza el ID del nuevo usuario
                userIdToUse = await createUser(formData);
            }
    
            // Asigna permisos y empresas en ambos casos
            const permissionsData = {
                user_id: userIdToUse,
                permisos: permisos.map(per => per.id),
                grupos : grupos.map(per => per.id),
                dashboards:dashboardSeleccionado.map(dash => dash.id),
                linea_negocio: lineaSeleccionada.map(linea => linea.id),
            };
            await assignPermissions(userIdToUse, permissionsData);
    
            onUserCreated(userIdToUse, formData);
            closeModal();
        } catch (error) {
            console.error("Error al procesar el usuario y asignar permisos:", error);
            alert("Error al procesar el usuario y asignar permisos.");
        }
    };

    useEffect(() => {
        if (isEditMode && userId) {
            const fetchUserData = async () => {
                try {
                    const response = await apiInstance.get(`/user/${userId}/`);
                    setFormData({
                        ...response.data,
                        password: '', // La contraseña normalmente no se transfiere
                    });
                    console.log(response.data)
                    setLineaSeleccionada(response.data.lineas_negocio)
                    setDashboardSeleccionado(response.data.dashboards)
                    setPermisos(response.data.permisos)
                    setGrupos(response.data.grupos)
                } catch (error) {
                    console.error('Error al cargar los datos del usuario:', error);
                }
            };

            fetchUserData();
        }
    }, [isEditMode, userId]);
    return (
        <Box>
            <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
                <Tab label="Crear Usuario" />
                <Tab label="Permisos" />
                <Tab label="Asignar Linea de Negocio" />
            </Tabs>

            {tabValue === 0 && (
                <Box>
                    <form onSubmit={handleSubmit}>
                    <FormControl fullWidth margin="normal">
                        <TextField label="Username" name="username" value={formData.username} onChange={handleChange} required />
                        {!isEditMode && <TextField label="Password" name="password" type="password" value={formData.password} onChange={handleChange} required />}
                        <TextField label="Tipo de Documento" name="type_document" value={formData.type_document} onChange={handleChange} />
                        <TextField label="Nombre" name="first_name" value={formData.first_name} onChange={handleChange} />
                        <TextField label="Apellido" name="last_name" value={formData.last_name} onChange={handleChange} />
                        <TextField label="DNI" name="dni" value={formData.dni} onChange={handleChange} />
                        <TextField label="Teléfono" name="phone" value={formData.phone} onChange={handleChange} />
                        <TextField label="Email" name="email" type="email" value={formData.email} onChange={handleChange} />
                        <FormControlLabel
                            control={<Checkbox name="is_active" checked={formData.is_active} onChange={handleChange} />}
                            label="Activo"
                        />
                        <FormControlLabel
                            control={<Checkbox name="is_superuser" checked={formData.is_superuser} onChange={handleChange} />}
                            label="Superusuario"
                        />
                        <FormControlLabel
                            control={<Checkbox name="is_staff" checked={formData.is_staff} onChange={handleChange} />}
                            label="Staff"
                        />
                    </FormControl>
                </form>
                </Box>
            )}

            {tabValue === 1 && (
                <Box>
                    <PermissionsComponent 
                      onSelectionPermissionsChange={setPermisos}
                      onSelectionGroupsChange ={setGrupos}
                      preselectedPermissions ={permisos}
                      preselectedGroups = {grupos}
                    
                    />
                </Box>
            )}

            {tabValue === 2 && (
                <Box>
                    <EmpresaDetailList
                        lineasSeleccionadas={lineaSeleccionada}
                        dashboardsPreseleccionados = {dashboardSeleccionado}
                        onLineaNegocioSelection={setLineaSeleccionada}
                        onDashboardSelection={setDashboardSeleccionado}
                    />
                    {/* Botón de Guardar solo visible en el tab 2 */}
                    <Button onClick={handleSubmit} variant="contained" color="primary">
                        Guardar
                    </Button>
                </Box>
            )}
        </Box>

    );
}

export default CreateUser;
